import {combineReducers} from "redux";

import appReducer from '../modules/appReducer'
import customerReducer from '../modules/Customer/customerReducer'
import ownerReducer from '../modules/Owner/ownerReducer'
import adminReducer from '../modules/Admin/adminReducer'
import uploadReducer from '../modules/uploadProgressReducer'
import userReducer from "./UserReducer/userReducer";

export default combineReducers({
    appReducer,
    customerReducer,
    ownerReducer,
    adminReducer,
    uploadReducer,
    userReducer
});
